module.exports = __webpack_public_path__ + "static/img/image01.0577dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/psychology/image01.jpg
// module id = 0M12
// module chunks = 0